import { ZillowNavbarState } from './types';

/**
 * Navbar configuration from https://www.zillow.com/homeloans/new/, ripped straight from production on
 * April 18th, 2024 at 1:27 PM EST (window.__PFS_TOPNAV_DATA__.pageHeaderProps)
 */
export const TOP_NAV_DATA: Omit<ZillowNavbarState, 'zhlHost'> = {
    drawerOnly: false,
    deferDropdowns: true,
    links: {
        logo: {
            text: 'Zillow Home Loans',
            href: '/homeloans',
        },
        main: {
            sections: [
                {
                    link: {
                        text: 'Buy',
                        href: '/homes/',
                        classString: 'noroute',
                    },
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'buy',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url: '/homes/',
                                level_one_txt: 'Buy',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'buy',
                    },
                    subsections: [
                        {
                            title: 'Homes for sale',
                            links: [
                                [
                                    {
                                        text: 'Homes for sale',
                                        href: '/homes/for_sale/',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/homes/for_sale/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'Homes for sale',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Foreclosures',
                                        href: '/homes/for_sale/fore_lt/',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/homes/for_sale/fore_lt/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'Foreclosures',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'For sale by owner',
                                        href: '/homes/fsbo/',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/homes/fsbo/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'For sale by owner',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Open houses',
                                        href: '/homes/for_sale/1_open/',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/homes/for_sale/1_open/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'Open houses',
                                                },
                                            },
                                        },
                                    },
                                ],
                                [
                                    {
                                        text: 'New construction',
                                        href: '/homes/new_homes/',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/homes/new_homes/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'New construction',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Coming soon',
                                        href: '/homes/coming_soon/cmsn_lt/',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/homes/coming_soon/cmsn_lt/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'Coming soon',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Recent home sales',
                                        href: '/homes/recently_sold/',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/homes/recently_sold/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'Recent home sales',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'All homes',
                                        href: '/browse/homes/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/browse/homes/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Homes for sale',
                                                    level_three_txt: 'All homes',
                                                },
                                            },
                                        },
                                    },
                                ],
                            ],
                        },
                        {
                            title: 'Resources',
                            links: [
                                [
                                    {
                                        text: 'Buyers Guide',
                                        href: '/home-buying-guide/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/home-buying-guide/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Resources',
                                                    level_three_txt: 'Buyers Guide',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Foreclosure center',
                                        href: '/foreclosures/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/foreclosures/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Resources',
                                                    level_three_txt: 'Foreclosure center',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Real estate app',
                                        href: '/z/buying/app-download/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/z/buying/app-download/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Resources',
                                                    level_three_txt: 'Real estate app',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Down payment assistance',
                                        href: '/down-payment-assistance/',
                                        gaClickEventObj: {
                                            category: 'TopNav',
                                            action: 'Down Payment Assistance',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/down-payment-assistance/',
                                                    level_one_txt: 'Buy',
                                                    level_two_txt: 'Resources',
                                                    level_three_txt: 'Down payment assistance',
                                                },
                                            },
                                        },
                                    },
                                ],
                            ],
                        },
                    ],
                },
                {
                    link: {
                        text: 'Rent',
                        href: '/homes/for_rent/',
                        classString: 'noroute',
                    },
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'rent',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url: '/homes/for_rent/',
                                level_one_txt: 'Rent',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'rent',
                    },
                    subsections: [
                        {
                            title: 'Search for rentals',
                            links: [
                                {
                                    text: 'Rental buildings',
                                    href: '/homes/for_rent/apartment_duplex_type/',
                                    classString: 'noroute',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/homes/for_rent/apartment_duplex_type/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Search for rentals',
                                                level_three_txt: 'Rental buildings',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Apartments for rent',
                                    href: '/homes/for_rent/condo,apartment_duplex_type/',
                                    classString: 'noroute',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/homes/for_rent/condo,apartment_duplex_type/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Search for rentals',
                                                level_three_txt: 'Apartments for rent',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Houses for rent',
                                    href: '/homes/for_rent/house_type/',
                                    classString: 'noroute',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/homes/for_rent/house_type/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Search for rentals',
                                                level_three_txt: 'Houses for rent',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'All rental listings',
                                    href: '/homes/for_rent/',
                                    classString: 'noroute',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/homes/for_rent/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Search for rentals',
                                                level_three_txt: 'All rental listings',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'All rental buildings',
                                    href: '/browse/b/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/browse/b/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Search for rentals',
                                                level_three_txt: 'All rental buildings',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            title: 'Renter Hub',
                            links: [
                                {
                                    text: 'Contacted rentals',
                                    href: '/renting/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/renting/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Renter Hub',
                                                level_three_txt: 'Contacted rentals',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Your rental',
                                    href: '/renting/your-rental/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/renting/your-rental/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Renter Hub',
                                                level_three_txt: 'Your rental',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Messages',
                                    href: '/renter-hub/inbox/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/renter-hub/inbox/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Renter Hub',
                                                level_three_txt: 'Messages',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            title: 'Resources',
                            links: [
                                {
                                    text: 'Affordability calculator',
                                    href: '/rent-affordability-calculator/',
                                    gaClickEventObj: {
                                        category: 'renter_tools',
                                        action: 'click',
                                        label: 'affordability',
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/rent-affordability-calculator/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Resources',
                                                level_three_txt: 'Affordability calculator',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Renters guide',
                                    href: '/rent/guide/',
                                    gaClickEventObj: {
                                        category: 'renter_tools',
                                        action: 'click',
                                        label: 'guide',
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/rent/guide/',
                                                level_one_txt: 'Rent',
                                                level_two_txt: 'Resources',
                                                level_three_txt: 'Renters guide',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    link: {
                        text: 'Sell',
                        href: '/sell/',
                    },
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'sell',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url: '/sell/',
                                level_one_txt: 'Sell',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'sell',
                    },
                    subsections: [
                        {
                            title: 'Resources',
                            links: [
                                {
                                    text: 'Explore your options',
                                    href: '/sell/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/sell/',
                                                level_one_txt: 'Sell',
                                                level_two_txt: 'Resources',
                                                level_three_txt: 'Explore your options',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: "See your home's Zestimate",
                                    href: '/how-much-is-my-home-worth/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/how-much-is-my-home-worth/',
                                                level_one_txt: 'Sell',
                                                level_two_txt: 'Resources',
                                                level_three_txt: "See your home's Zestimate",
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Home values',
                                    href: '/home-values/102001/united-states/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/home-values/102001/united-states/',
                                                level_one_txt: 'Sell',
                                                level_two_txt: 'Resources',
                                                level_three_txt: 'Home values',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Sellers guide',
                                    href: '/sellers-guide/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/sellers-guide/',
                                                level_one_txt: 'Sell',
                                                level_two_txt: 'Resources',
                                                level_three_txt: 'Sellers guide',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            title: 'Selling options',
                            links: [
                                {
                                    text: "Find a seller's agent",
                                    href: '/professionals/real-estate-agent-reviews/?service=Selling',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/professionals/real-estate-agent-reviews/?service=Selling',
                                                level_one_txt: 'Sell',
                                                level_two_txt: 'Selling options',
                                                level_three_txt: "Find a seller's agent",
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Post For Sale by Owner',
                                    href: '/for-sale-by-owner/',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url: '/for-sale-by-owner/',
                                                level_one_txt: 'Sell',
                                                level_two_txt: 'Selling options',
                                                level_three_txt: 'Post For Sale by Owner',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    link: {
                        text: 'Home Loans',
                        href: '/home-loans/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgagestopnav#source=Z_Mortgagestopnav',
                    },
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'home_loans',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url:
                                    '/home-loans/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgagestopnav#source=Z_Mortgagestopnav',
                                level_one_txt: 'Home Loans',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'home_loans',
                    },
                    subsections: [
                        {
                            title: 'Touring homes & making offers',
                            links: [
                                {
                                    text: 'Discover Zillow Home Loans',
                                    href: '/home-loans/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/home-loans/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Touring homes & making offers',
                                                level_three_txt: 'Discover Zillow Home Loans',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'See how much you qualify for',
                                    href: '/homeloans/eligibility/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav&zga_z_guid=06609eef-552f-4a25-9ced-ed92477adca8',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/homeloans/eligibility/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav&zga_z_guid=06609eef-552f-4a25-9ced-ed92477adca8',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Touring homes & making offers',
                                                level_three_txt: 'See how much you qualify for',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Estimate your monthly payment',
                                    href: '/mortgage-calculator/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/mortgage-calculator/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Touring homes & making offers',
                                                level_three_txt: 'Estimate your monthly payment',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            title: 'Just getting started',
                            links: [
                                {
                                    text: 'Calculate your budget',
                                    href: '/mortgage-calculator/house-affordability/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/mortgage-calculator/house-affordability/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Just getting started',
                                                level_three_txt: 'Calculate your budget',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Learn about the mortgage process',
                                    href: '/learn/category/financing/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/learn/category/financing/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Just getting started',
                                                level_three_txt: 'Learn about the mortgage process',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            title: 'Explore more options',
                            links: [
                                {
                                    text: "See today's rates",
                                    href: '/mortgage-rates/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/mortgage-rates/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Explore more options',
                                                level_three_txt: "See today's rates",
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Refinance your home',
                                    href: '/homeloans/refinance/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav&zga_z_guid=06609eef-552f-4a25-9ced-ed92477adca8',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/homeloans/refinance/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav&zga_z_guid=06609eef-552f-4a25-9ced-ed92477adca8',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Explore more options',
                                                level_three_txt: 'Refinance your home',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Calculate your refinance savings',
                                    href: '/mortgage-calculator/refinance-calculator/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/mortgage-calculator/refinance-calculator/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Explore more options',
                                                level_three_txt: 'Calculate your refinance savings',
                                            },
                                        },
                                    },
                                },
                                {
                                    text: 'Browse lenders in your area',
                                    href: '/lender-directory/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                    gaClickEventObj: {
                                        newLaneEvent: {
                                            envelope: {
                                                event_client_start_dtm: 'Thu Apr 18 2024',
                                                event_type_id: '3781',
                                                event_type_version_id: '1',
                                                event_template_id: '242',
                                                event_template_version_id: '1',
                                            },
                                            clickstream_trigger: {
                                                trigger_type_nm: 'interaction',
                                                trigger_location_nm: 'top_navigation',
                                                trigger_source_nm: 'top_navigation',
                                                trigger_object_nm: 'no_trigger_object',
                                            },
                                            semantic: {
                                                semantic_event_nm: 'top_nav_click',
                                            },
                                            top_navigation: {
                                                target_url:
                                                    '/lender-directory/?utm_source=zillow&utm_medium=referral&utm_campaign=Z_Mortgageshovertopnav#source=Z_Mortgageshovertopnav',
                                                level_one_txt: 'Home Loans',
                                                level_two_txt: 'Explore more options',
                                                level_three_txt: 'Browse lenders in your area',
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    link: {
                        text: 'Agent finder',
                        href: '/professionals/real-estate-agent-reviews/',
                    },
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'agent_finder',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url: '/professionals/real-estate-agent-reviews/',
                                level_one_txt: 'Agent finder',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'agent_finder',
                    },
                    subsections: [
                        {
                            title: 'Looking for pros?',
                            links: [
                                [
                                    {
                                        text: 'Real estate agents',
                                        href: '/professionals/real-estate-agent-reviews/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/professionals/real-estate-agent-reviews/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: 'Looking for pros?',
                                                    level_three_txt: 'Real estate agents',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Property managers',
                                        href: '/professionals/property-manager-reviews/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/professionals/property-manager-reviews/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: 'Looking for pros?',
                                                    level_three_txt: 'Property managers',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Home inspectors',
                                        href: '/professionals/home-inspector-reviews/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/professionals/home-inspector-reviews/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: 'Looking for pros?',
                                                    level_three_txt: 'Home inspectors',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Other pros',
                                        href: '/professionals/real-estate-services-reviews/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/professionals/real-estate-services-reviews/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: 'Looking for pros?',
                                                    level_three_txt: 'Other pros',
                                                },
                                            },
                                        },
                                    },
                                ],
                                [
                                    {
                                        text: 'Home improvement pros',
                                        href: '/professionals/home-improvement-reviews/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/professionals/home-improvement-reviews/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: 'Looking for pros?',
                                                    level_three_txt: 'Home improvement pros',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Home builders',
                                        href: '/home-builders/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/home-builders/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: 'Looking for pros?',
                                                    level_three_txt: 'Home builders',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Real estate photographers',
                                        href: '/professionals/photographer-reviews/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/professionals/photographer-reviews/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: 'Looking for pros?',
                                                    level_three_txt: 'Real estate photographers',
                                                },
                                            },
                                        },
                                    },
                                ],
                            ],
                        },
                        {
                            title: "I'm a pro",
                            links: [
                                [
                                    {
                                        text: 'Agent advertising',
                                        href: 'https://premieragent.zillow.com/products/advertising/?itc=paw_z_sitewide-agentfinder_subnav-advertising_pa-ads_a_null',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        'https://premieragent.zillow.com/products/advertising/?itc=paw_z_sitewide-agentfinder_subnav-advertising_pa-ads_a_null',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: "I'm a pro",
                                                    level_three_txt: 'Agent advertising',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Agent resource center',
                                        href: '/agent-resources/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/agent-resources/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: "I'm a pro",
                                                    level_three_txt: 'Agent resource center',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Create a free agent account',
                                        href: '/premier-agent/agent-account/?itc=paw_z_sitewide-agentfinder_subnav-createagentaccount_pa-reg_a_null',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/premier-agent/agent-account/?itc=paw_z_sitewide-agentfinder_subnav-createagentaccount_pa-reg_a_null',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: "I'm a pro",
                                                    level_three_txt: 'Create a free agent account',
                                                },
                                            },
                                        },
                                    },
                                ],
                                [
                                    {
                                        text: 'Real estate business plan',
                                        href: '/agent-resources/agent-toolkit/real-estate-business-plan-template/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/agent-resources/agent-toolkit/real-estate-business-plan-template/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: "I'm a pro",
                                                    level_three_txt: 'Real estate business plan',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Real estate agent scripts',
                                        href: '/agent-resources/agent-toolkit/real-estate-follow-up-email-templates/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/agent-resources/agent-toolkit/real-estate-follow-up-email-templates/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: "I'm a pro",
                                                    level_three_txt: 'Real estate agent scripts',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Listing flyer templates',
                                        href: '/agent-resources/agent-toolkit/real-estate-listing-flyer-templates/',
                                        gaClickEventObj: {
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/agent-resources/agent-toolkit/real-estate-listing-flyer-templates/',
                                                    level_one_txt: 'Agent finder',
                                                    level_two_txt: "I'm a pro",
                                                    level_three_txt: 'Listing flyer templates',
                                                },
                                            },
                                        },
                                    },
                                ],
                            ],
                        },
                    ],
                },
            ],
        },
        agent: false,
        marketing: {
            sections: [
                {
                    link: {
                        text: 'Manage Rentals',
                        href: '/rental-manager/?source=topnav&itc=postbutton_sitenav',
                        classString: 'noroute',
                    },
                    classString: 'znav-manage-rentals',
                    id: 'manage-rentals',
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'manage_rentals',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url: '/rental-manager/?source=topnav&itc=postbutton_sitenav',
                                level_one_txt: 'Manage Rentals',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'manage_rentals',
                    },
                    subsections: [
                        {
                            title: 'Rental Management Tools',
                            links: [
                                [
                                    {
                                        text: 'List a rental',
                                        href: '/rental-manager/post-a-listing?itc=ltr_zw_ltr_zrm-home_tpnv_post-a-listing',
                                        id: 'list_a_rental',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'list',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/rental-manager/post-a-listing?itc=ltr_zw_ltr_zrm-home_tpnv_post-a-listing',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Rental Management Tools',
                                                    level_three_txt: 'List a rental',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'My Listings',
                                        href: '/rental-manager/select-property?type=listings&source=topnav&itc=postbutton_topnav',
                                        id: 'my_listings',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'listing',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/rental-manager/select-property?type=listings&source=topnav&itc=postbutton_topnav',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Rental Management Tools',
                                                    level_three_txt: 'My Listings',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Messages',
                                        href: '/rental-manager/inbox/',
                                        id: 'messages',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'messages',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/rental-manager/inbox/',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Rental Management Tools',
                                                    level_three_txt: 'Messages',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Applications',
                                        href: '/rental-manager/select-property?type=applications&source=topnav&itc=postbutton_topnav',
                                        id: 'applications',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'applications',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/rental-manager/select-property?type=applications&source=topnav&itc=postbutton_topnav',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Rental Management Tools',
                                                    level_three_txt: 'Applications',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Leases',
                                        href: '/rental-manager/select-property?type=leases&source=topnav&itc=postbutton_topnav',
                                        id: 'leases',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'leases',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/rental-manager/select-property?type=leases&source=topnav&itc=postbutton_topnav',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Rental Management Tools',
                                                    level_three_txt: 'Leases',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Payments',
                                        href: '/rental-manager/select-property?type=payments&source=topnav&itc=postbutton_topnav',
                                        id: 'payments',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'payments',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/rental-manager/select-property?type=payments&source=topnav&itc=postbutton_topnav',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Rental Management Tools',
                                                    level_three_txt: 'Payments',
                                                },
                                            },
                                        },
                                    },
                                ],
                            ],
                        },
                        {
                            title: 'Learn More',
                            links: [
                                [
                                    {
                                        text: 'Zillow Rental Manager',
                                        href: '/rental-manager/?source=topnav&itc=list_zrm_topnav',
                                        id: 'zrm',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'about',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/rental-manager/?source=topnav&itc=list_zrm_topnav',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Learn More',
                                                    level_three_txt: 'Zillow Rental Manager',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Price My Rental',
                                        href: '/rental-manager/price-my-rental/?itc=ltr_zw_ltr_zrm-home_tpnv_price-my-rental',
                                        id: 'price_my_rental',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'price',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url:
                                                        '/rental-manager/price-my-rental/?itc=ltr_zw_ltr_zrm-home_tpnv_price-my-rental',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Learn More',
                                                    level_three_txt: 'Price My Rental',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Resource Center',
                                        href: '/rental-manager/resources/',
                                        id: 'resource_center',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'resource',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: '/rental-manager/resources/',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Learn More',
                                                    level_three_txt: 'Resource Center',
                                                },
                                            },
                                        },
                                    },
                                    {
                                        text: 'Help Center',
                                        href: 'https://help.zillowrentalmanager.com/hc/en-us/',
                                        id: 'help_center',
                                        classString: 'noroute',
                                        gaClickEventObj: {
                                            category: 'manage_rentals',
                                            action: 'click',
                                            label: 'help',
                                            newLaneEvent: {
                                                envelope: {
                                                    event_client_start_dtm: 'Thu Apr 18 2024',
                                                    event_type_id: '3781',
                                                    event_type_version_id: '1',
                                                    event_template_id: '242',
                                                    event_template_version_id: '1',
                                                },
                                                clickstream_trigger: {
                                                    trigger_type_nm: 'interaction',
                                                    trigger_location_nm: 'top_navigation',
                                                    trigger_source_nm: 'top_navigation',
                                                    trigger_object_nm: 'no_trigger_object',
                                                },
                                                semantic: {
                                                    semantic_event_nm: 'top_nav_click',
                                                },
                                                top_navigation: {
                                                    target_url: 'https://help.zillowrentalmanager.com/hc/en-us/',
                                                    level_one_txt: 'Manage Rentals',
                                                    level_two_txt: 'Learn More',
                                                    level_three_txt: 'Help Center',
                                                },
                                            },
                                        },
                                    },
                                ],
                            ],
                        },
                    ],
                },
                {
                    link: {
                        text: 'Advertise',
                        href: '/z/partners/advertise/',
                    },
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'advertise',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url: '/z/partners/advertise/',
                                level_one_txt: 'Advertise',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'advertise',
                    },
                },
            ],
        },
        regLogin: {
            sections: [
                {
                    link: {
                        text: 'Sign in',
                        href: '/user/acct/login/?cid=pf',
                    },
                },
                {
                    link: {
                        text: 'Join',
                        href: '/user/acct/register/?cid=pf',
                    },
                },
            ],
        },
        help: {
            sections: [
                {
                    link: {
                        text: 'Help',
                        href: 'https://zillow.zendesk.com/hc/en-us/',
                    },
                    gaHoverEventObj: {
                        category: 'nav_menu',
                        action: 'mouseover',
                        label: 'help',
                        newLaneEvent: {
                            envelope: {
                                event_client_start_dtm: 'Thu Apr 18 2024',
                                event_type_id: '3784',
                                event_type_version_id: '1',
                                event_template_id: '242',
                                event_template_version_id: '1',
                            },
                            clickstream_trigger: {
                                trigger_type_nm: 'interaction',
                                trigger_location_nm: 'top_navigation',
                                trigger_source_nm: 'top_navigation',
                                trigger_object_nm: 'no_trigger_object',
                            },
                            semantic: {
                                semantic_event_nm: 'top_nav_hover',
                            },
                            top_navigation: {
                                target_url: 'https://zillow.zendesk.com/hc/en-us/',
                                level_one_txt: 'Help',
                                level_two_txt: null,
                                level_three_txt: null,
                            },
                        },
                    },
                    gaExpandoClickObj: {
                        category: 'nav_menu',
                        action: 'click_down',
                        label: 'help',
                    },
                },
            ],
        },
        common: {
            home: {
                text: 'Zillow Real Estate',
                href: '/',
                gaClickEventObj: {},
            },
            advertise: {
                text: 'Advertise',
                href: '/advertise/',
                gaClickEventObj: {},
            },
            login: {
                text: 'Sign in',
                href: '/user/acct/login/',
            },
            register: {
                text: 'Join',
                href: '/user/acct/register/',
            },
        },
    },
    staticDomainConfig: {
        host: 's.zillowstatic.com',
        protocol: 'https',
    },
    enableZIM: true,
    useVisualRefreshTheme: false,
};
